import { frontendURL } from 'dashboard/helper/URLHelper';
import { isTeletelCallCenterEnabledForAccount } from 'dashboard/helper/teletelCallCenter';

export const redirectCallCenterIfDisabled = (to, _from, next) => {
  if (isTeletelCallCenterEnabledForAccount(to.params.accountId)) {
    next();
    return;
  }

  next({ name: 'home', params: { accountId: to.params.accountId } });
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/call-center'),
      name: 'teletel_call_center',
      beforeEnter: redirectCallCenterIfDisabled,
      component: () => import('./Index.vue'),
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
    },
  ],
};
